import React from 'react';
import ProjectFeedbackFeed from '@/components/module/projects/ProjectFeedbackFeed';

export default function ProjectFeedbackTab({ projectId }) {
    return <ProjectFeedbackFeed projectId={projectId} />;
}
